import { render } from "./disciplinaCadastro.vue?vue&type=template&id=3af61ad8"
import script from "./disciplinaCadastro.vue?vue&type=script&lang=js"
export * from "./disciplinaCadastro.vue?vue&type=script&lang=js"

import "./disciplinaCadastro.vue?vue&type=style&index=0&id=3af61ad8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__